<template>
  <a
    :href="href"
    :target="target"
    :title="title"
    class="app-footer-link__container"
    >{{ text }}</a
  >
</template>

<script>
export default {
  name: 'AppFooterLink',
  props: {
    href: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: 'Title'
    },
    target: {
      type: String,
      default: '_blank'
    },
    text: {
      type: String,
      default: 'Text'
    }
  }
}
</script>

<style sc>
.app-footer-link__container {
  font-family: "Avenir-Medium";
  font-size: 1.125rem;
  height: 1.56rem;
  color: #ff8511;
  letter-spacing: 0;
  text-align: center;
  margin-top: 0.75rem;
}
</style>
